const MAIN_PANEL = {
  xs: {
    size: 12,
    offset: 0
  },
  sm: {
    size: 12,
    offset: 0
  },
  md: {
    size: 9,
    offset: 0
  },
  lg: {
    size: 9,
    offset: 0
  },
  xl: {
    size: 8,
    offset: 0
  }
};
const SIDE_PANEL = {
  xs: {
    size: 12,
    offset: 0
  },
  sm: {
    size: 12,
    offset: 0
  },
  md: {
    size: 3,
    offset: 0
  },
  lg: {
    size: 3,
    offset: 0
  },
  xl: {
    size: 2,
    offset: 0
  }
};

const SEARCH_GROUP_ROW_PROPS = {
  className: "justify-content-end",
  noGutters: true
};

const SEARCH_BOX_PROPS = {
  xs: {size: 12},
  sm: {size: 12},
  md: {size: 6},
  lg: {size: 3},
  xl: {size: 3},
  style: {
    padding: "2px",
    paddingTop: "0px"
  }
};

export const ViewConfig = {
  MAIN_PANEL,
  SIDE_PANEL,
  SEARCH_GROUP_ROW_PROPS,
  SEARCH_BOX_PROPS
};
